import ColoredPercentileItem from './ColoredPercentileItem';
import LinearProgressFiller from './LinearProgressFiller';
import { Flex } from './base/layout-components';
import React from 'react';

const WorkBreakdownProgressBar = ({
  configurations,
  textFirstOnItems,
  ...rest
}) => {
  return (
    <Flex
      direction='column'
      justify='space-between'
      pl='small'
      pr='small'
      {...rest}
    >
      <LinearProgressFiller isRound={false} parts={configurations} />
      <Flex>
        {configurations.map(config => (
          <ColoredPercentileItem
            textFirst={textFirstOnItems}
            padding={`0 ${16 / configurations.length}rem 0 0`}
            key={config.text}
            {...config}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default WorkBreakdownProgressBar;
